
import {request} from "./request";

// 单位列表
export function get_goods_unit_list(params) {
	return request({
		url: '/hkt/goodsunit/get_goods_unit_list',
		params,
	})
}
// --------------------------------------------------------
// 订单 start ---------------------------------
// -订单字段分类- start
// 订单分类  添加 
export function add_order_group(name) {
    return request({
        url: '/hkt/ordergroup/add_order_group',
        params: {
            name,
        }
    })
};
 
// 订单分类 删除
export function del_order_group(group_id) {
    return request({
        url: '/hkt/ordergroup/del_order_group',
        params: {
            group_id,
        }
    })
};

// 订单分类 修改
export function edit_order_group(group_id, name) {
    return request({
        url: '/hkt/ordergroup/edit_order_group',
        params: {
            group_id,
			name
        }
    })
};

// 订单分类 列表
export function get_order_group_list(pagesize, page) {
    return request({
        url: '/hkt/ordergroup/get_order_group_list',
        params: {
            pagesize,
			page,
        }
    })
};

// 订单分类 排序
export function sort_order_group(group_ids) {
    return request({
        url: '/hkt/ordergroup/sort_order_group',
        params: {
			group_ids,
        }
    })
};
// -订单字段分类- end

// -订单字段- start
// 订单字段 添加
// field	是	string	订单字段
// field_type	是	int	字段类型0:系统类型1:单行文本2:多行文本3：时间4：数字5：单选6：多选7:附件8：图片
// group_id	是	int	分组id
// state	是	int	启用状态0:不启用1：启用
// field_config	否	string	字段配置
export function add_order_field(params) {
    return request({
        url: '/hkt/orderfield/add_order_field',
        params,
    })
};

// 订单字段 删除
// field_id
export function del_order_field(field_id) {
    return request({
        url: '/hkt/orderfield/del_order_field',
        params: {
            field_id,
        }
    })
};

// 订单字段 修改
// field_id	是	int	id
// field	是	string	订单字段
// group_id	是	int	分组id
// state	是	int	启用状态0:不启用1：启用
// field_config	否	string	字段配置
export function edit_order_field(params) {
    return request({
        url: '/hkt/orderfield/edit_order_field',
        params,
    })
};

// 订单字段 修改状态
// field_id	是	int
// state	是	int	状态
export function operation_order_field(field_id, state) {
    return request({
        url: '/hkt/orderfield/operation_order_field',
        params: {
            field_id,
			state,
        }
    })
};

// 订单字段 列表
export function get_order_field_list(pagesize, page) {
    return request({
        url: '/hkt/orderfield/get_order_field_list',
        params: {
            pagesize,
            page,
        }
    })
};
// 订单字段 列表2
export function get_order_field_list2(pagesize, page) {
    return request({
        url: '/hkt/orderfield/get_order_field_list2',
        params: {
            pagesize,
            page,
        }
    })
};

// -订单字段- end

// -订单状态- start
// 订单状态 添加
export function add_order_status(name) {
    return request({
        url: '/hkt/orderstatus/add_order_status',
        params: {
			name,
        }
    })
};

// 订单状态 删除
export function del_order_status(status_id) {
    return request({
        url: '/hkt/orderstatus/del_order_status',
        params: {
			status_id,
        }
    })
};

// 订单状态 修改
export function edit_order_status(status_id, name) {
    return request({
        url: '/hkt/orderstatus/edit_order_status',
        params: {
			status_id,
			name,
        }
    })
};

// 订单状态 列表
export function get_order_status_list() {
    return request({
        url: '/hkt/orderstatus/get_order_status_list',
        params: {
			pagesize: 999,
			page: 1,
        }
    })
};

// 订单状态 排序
export function sort_order_status(status_ids) {
    return request({
        url: '/hkt/orderstatus/sort_order_status',
        params: {
			status_ids,
        }
    })
};

// -订单状态- end

// 订单列表，详情页
// 添加订单
// dd_code	是	string	订单编号
// order_time	是	int	订单时间
// customer_id	是	int	客户id
// contact_id	是	int	联系人id
// status_id	是	int	状态id
// member_id	是	int	成员id
// assistant_member_id	否	string	协助人
// goods_id	是	string	商品id 逗号间隔末尾加逗号
// discount_amount	否	int	整单折扣额
// discount_rate	否	int	整单折扣率
// return_id	否	string	回款id 逗号间隔加逗号
// order_info	是	string	订单信息
// goods_info	是	string	商品信息
export function add_order(data) {
    return request({
        url: '/hkt/order/add_order',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
    })
};
// 刪除订单
export function del_order(order_ids) {
    return request({
        url: '/hkt/order/del_order',
        params: {
			order_ids,
        }
    })
};
// 修改订单
// order_id	是	int	订单id
// dd_code	是	string	订单编号
// order_time	是	int	订单时间
// customer_id	是	int	客户id
// contact_id	是	int	联系人id
// status_id	是	int	状态id
// member_id	是	int	成员id
// assistant_member_id	否	string	协助人
// goods_id	是	string	商品id 逗号间隔末尾加逗号
// discount_amount	否	int	整单折扣额
// discount_rate	否	int	整单折扣率
// return_id	否	string	回款id 逗号间隔加逗号
// order_info	是	string	订单信息
// goods_info	是	string	商品信息
export function edit_order(data) {
    return request({
        url: '/hkt/order/edit_order',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
    })
};
// 订单列表获取
// pagesize	是	int	每页数量
// member_id	否	int	成员id
// status_id	否	int	状态id
// search_name	否	string	搜索名称
// create_time	否	string	创建时间
// return_id	否	int	回款id
// customer_id	否	int	客户id
// is_recycle	否	int	是否回收
// sort_type	否	int	排序
export function get_order_list(params) {
    return request({
        url: '/hkt/order/get_order_list',
        params,
    })
};
// 详情
export function get_order_details(order_id) {
    return request({
        url: '/hkt/order/get_order_details',
        params: {
			order_id,
		},
    })
};
// 批量修改
// edit_info	是	string	修改信息
export function batch_edit_order(data) {
    return request({
        url: '/hkt/order/batch_edit_order',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
    })
};

// 回收订单 加入回收站
// order_ids	是	string	订单id
// is_recycle	是	int	是否回收 传0就是恢复，传1就是回收
export function recycle_order(order_ids, is_recycle) {
    return request({
        url: '/hkt/order/recycle_order',
        params: {
			order_ids,
			is_recycle,
		},
    })
};
// 设置订单配置
// order_config	是	string	订单配置
export function set_order_config(order_config) {
    return request({
        url: '/hkt/order/set_order_config',
        params: {
			order_config,
		},
    })
};

// 设置订单字段排序
// field_ids	是	string	字段id	逗号间隔
export function sort_order_field(field_ids) {
    return request({
        url: '/hkt/orderfield/sort_order_field',
        params: {
			field_ids,
		},
    })
};



// 获取订单计算数据
// goods_info	是	string	产品信息
// discount_amount	否	int	折扣额
// discount_rate	否	int	折扣率
// return_id	否	string	回款id
export function get_order_compute(data) {
    return request({
        url: '/hkt/order/get_order_compute',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
    })
};

// 获取订单自定义
export function getCustomFeatures(type){
	let res = ''
	let order_config = localStorage.order_config || ''
	if(order_config && typeof(order_config) == 'string') {
		let Jsres = JSON.parse(order_config)
		if(type == 1) {
		 	res = Jsres.orderlist
		}
		else if(type == 2) {
		 	res = Jsres.product
		}
	}
	return res;
}

// 订单 end   ---------------------------------